import { DEFAULT_CURRENCY } from "@repo/shared";
import { useParams } from "react-router";

import {
  useAssetClasses,
  usePortfolioCollectionSettings,
  useProducts,
} from "@/lib/hooks/use-portfolio-collections";

import { TableCardSkeleton } from "../skeleton-loaders";
import { CorrelationEmptyState } from "./correlation-empty-state";
import { CorrelationMatrix } from "./correlation-matrix";
import { ProductCorrelationMatrix } from "./product-correlation-matrix";

export default function CorrelationsPage() {
  const { id } = useParams<{ id: string }>();
  const { settings, isLoading: settingsLoading } = usePortfolioCollectionSettings(id!);
  const isProductsMode = settings?.calculationsMode === "products";

  const { assetClasses, isLoading: assetClassesLoading } = useAssetClasses(id!);
  const { products, isLoading: productsLoading } = useProducts(id!);

  if (settingsLoading) {
    return <TableCardSkeleton columns={4} rows={4} />;
  }

  if (isProductsMode) {
    if (productsLoading) {
      return <TableCardSkeleton columns={4} rows={4} />;
    }
    if (products.length < 2) {
      return <CorrelationEmptyState mode="products" />;
    }
    return <ProductCorrelationMatrix portfolioCollectionId={id!} products={products} />;
  }

  if (assetClassesLoading) {
    return <TableCardSkeleton columns={4} rows={4} />;
  }
  if (assetClasses.length < 2) {
    return <CorrelationEmptyState mode="asset_classes" />;
  }
  return (
    <CorrelationMatrix
      portfolioCollectionId={id!}
      assetClasses={assetClasses}
      currency={settings?.currency ?? DEFAULT_CURRENCY}
    />
  );
}
